import React from 'react'
import PropTypes from 'prop-types'

const InteractiveActionBar = ({ nextActors, selectedActor }) => (
    <div className="interactiveActionsBar">
        {
            nextActors.map((actor, index) => {
                const {
                    ID, faction, avatar,
                } = actor
                const key = `${ID}_${index}`
                const selectedClass = selectedActor === ID ? 'selected' : ''
                return (
                    <div key={key} className={`iab__slot iab__slot--${faction} ${selectedClass}`}>
                        {avatar}
                    </div>
                )
            })
        }
    </div>
)

InteractiveActionBar.propTypes = {
    nextActors: PropTypes.array.isRequired,
    selectedActor: PropTypes.string.isRequired,
}

export default InteractiveActionBar
